module.exports = __webpack_public_path__ + "static/img/default.cef8e99d.png";